import { render } from "./Recipes.vue?vue&type=template&id=c4e5f6d2&scoped=true"
import script from "./Recipes.vue?vue&type=script&lang=js"
export * from "./Recipes.vue?vue&type=script&lang=js"

import "./Recipes.vue?vue&type=style&index=0&id=c4e5f6d2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c4e5f6d2"]])

export default __exports__